module.exports = __webpack_public_path__ + "static/media/mail-icon.01bf6a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AppleMailLogo/mail-icon.png
// module id = 86
// module chunks = 0